import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { customerContainer } from 'src/models'
import { renderRoutes } from 'src/routes'
import { isB2BAdmin, isAccountProfileDelegatedRoute, enableAccountProfileMFE } from 'src/utils'
import { pageNames } from 'src/routes/pathParams'
import { myAccountSideBar } from './myAccountSideBar'
import { getLiveEventStatus } from 'src/utils'
import { useScrollManager } from 'src/utils/customScrollManager'

const myaccountLandingPage = isB2BAdmin()
  ? pageNames.home
  : pageNames.myaccountprofile

const MyAccountSection = ({ routes }) => {
  const history = useHistory()
  const location = useLocation()
  const [enableLiveEvent] = useState(getLiveEventStatus())

  const scrollManager = useScrollManager({
    customElementId: 'my-account-details-wrapper',
    forceScrollOnMount: true,
    forceScrollOnRouteChange: true,
    maxScrollDuration: 0,
    scrollCheckInterval: 200,
  })

  const checkIfAuthorizedPage = routes => {
    return routes.some(route => route.link === location.pathname)
  }

  const checkPathName = path => {
    return location?.pathname === path
  }

  const isToIgnoreRedirection = () => {
    const ignoreRedirectionUrls = [
      pageNames.b2bAccountTypeConvert,
      pageNames.manageSubscription,
      pageNames.myaccountdirectselleridcard,
    ]
    // Delegated account-profile routes (rendered here via the full-shell delegation) are
    // always authorized — never bounce them to the landing page.
    // Guard must be gated on the flag so US/CA markets still enforce auth on /myaccount/favorites.
    return (
      (enableAccountProfileMFE() && isAccountProfileDelegatedRoute(location?.pathname)) ||
      ignoreRedirectionUrls.some(pageName => checkPathName(pageName))
    )
  }

  useEffect(() => {
    const initializeAccount = async () => {
      await customerContainer.getProfile({ fromOnLoad: true })
      const sideBarResponse = myAccountSideBar()

      if (!checkIfAuthorizedPage(sideBarResponse)) {
        if (!isToIgnoreRedirection()) {
          history.push(myaccountLandingPage)
        }
      }
    }

    initializeAccount()
  }, [history])

  return (
    <section
      id="my-account-details-wrapper"
      className={`account-details-wrapper ${
        enableLiveEvent === 'true' ? 'live-event-enabled' : ''
      }`}
      style={{
        position: 'relative',
        top: 0,
      }}
      /**
       * @note
       * Commenting aria-live for double announcement of field validation - CX121-1802
       */
      // aria-live="polite"
    >
      {renderRoutes(routes)}
    </section>
  )
}

export default MyAccountSection
export { MyAccountSection }
